import { Trans } from '@lingui/react/macro';

import { Message } from '../../ui';

/**
 * Standard error component for tools when no data is available or response cannot be processed
 */
export function ToolNoDataError() {
  return (
    <Message.BubbleGroup>
      <Message.Bubble>
        <Trans>Unable to process response. Please try again.</Trans>
      </Message.Bubble>
    </Message.BubbleGroup>
  );
}
